/* eslint-disable complexity */
import React from 'react';
import { Select, Option } from 'carbon-react/lib/components/select';
import classNames from 'classnames';

import { useIntl } from '@futrli/localisation';

import { adaptSelectChange } from '../../../../utils/carbon-select';

import { InputMethod } from '../../types';
import * as styles from './input-method-menu.scss';

interface InputMethodMenuProps {
  className?: string;
  disabled?: boolean;
  error?: boolean;
  label?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  options: InputMethod[];
  value?: InputMethod;
  width?: number;
  size?: 'small' | 'medium' | 'large';
  required?: boolean;
}

export const InputMethodMenu = ({
  disabled = false,
  error,
  label,
  onChange,
  options,
  value,
  width,
  size = 'large',
  required
}: InputMethodMenuProps) => {
  const intl = useIntl();

  // Need to do it this way as the Carbon Select component doesn't work well with null/undefined values
  // (it will leave blank spaces where options should be as it calculates its height based on number of children)
  const dropdownOptions = [
    options && options.includes(InputMethod.FORMULA) ? (
      <Option
        value={InputMethod.FORMULA}
        text={intl.formatMessage({ id: 'common.formula', defaultMessage: 'Formula' })}
      />
    ) : null,
    options && options.includes(InputMethod.FREESTYLE) ? (
      <Option
        value={InputMethod.FREESTYLE}
        text={intl.formatMessage({ id: 'predict.freestyle', defaultMessage: 'Freestyle' })}
      />
    ) : null,
    // options && options.includes(InputMethod.REPEATING) ? (
    //   <Option
    //     value={InputMethod.REPEATING}
    //     text={intl.formatMessage({ id: 'common.repeating', defaultMessage: 'Repeating' })}
    //   />
    // ) : null,
    // options && options.includes(InputMethod.UNIT) ? (
    //   <Option value={InputMethod.UNIT} text={intl.formatMessage({ id: 'common.unit', defaultMessage: 'Unit' })} />
    // ) : null,
    options && options.includes(InputMethod.EXCEL) ? (
      <Option
        value={InputMethod.EXCEL}
        text={intl.formatMessage({
          id: 'predict.non_financial_drivers.upload_drivers_from_excel',
          defaultMessage: 'Upload drivers from Excel'
        })}
      />
    ) : null
  ].filter(o => o !== null);

  return (
    <div style={{ minWidth: 135, marginRight: 16 }} className={classNames({ [styles.disabledContainer]: disabled })}>
      <Select
        data-testid="InputMethodMenu"
        value={value ?? ''}
        autoComplete="off"
        onChange={adaptSelectChange<HTMLInputElement | HTMLTextAreaElement>(onChange)}
        label={
          label ||
          intl.formatMessage({
            id: 'predict.input_method',
            defaultMessage: 'Input method'
          })
        }
        disabled={disabled}
        error={error}
        size={size}
        mb={0}
        width={width}
        required={required}
      >
        {dropdownOptions}
      </Select>
    </div>
  );
};
